<main class="container">
  <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout39">
    <left-menu [showImportExport]="false" />
  </section>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h2>Units</h2>
        <fieldset class="border rounded-3 p-3">
          <legend class="subtitle-4 float-none w-auto px-3">Units</legend>
          <div class="container">
            <div class="form-group row align-items-center">
              <div class="col-sm-6 align-self-center">
                <input type="radio" id="radioButton1_DI" name="radioButton_DI" [(ngModel)]="unitSelected" [value]="0" (change)="onChange(0)" />
                <label for="radioButton1_DI">&nbsp;US Customary</label>
              </div>
              <div class="col-sm-6">
                <input type="radio" id="radioButton2_DI" name="radioButton_DI" [(ngModel)]="unitSelected" [value]="1" (change)="onChange(1)" />
                <label for="radioButton2_DI">&nbsp;SI</label>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </section>
</main>
